<div class="digi-trainer-container">
    <h3 class="title">
        <img [src]="'sidebar/sidebar-icon-digitrainer.png' | asset" alt="">
        digi.trainer
    </h3>

    <div class="digi-trainer-content last-used">
        <h3>
            <span>
                <i class="fas fa-undo fa-flip-horizontal"></i>
                Zuletzt geübt
            </span>
        </h3>

        <button class="btn btn-round"
                (click)="quicklinkClick(lastOpenedAssignments)"
                [disabled]="!lastOpenedAssignments || lastOpenedAssignments?.length === 0"
                title="weitermachen"
        >
            weitermachen
        </button>
    </div>

    <div class="digi-trainer-content skills">
        <h3>
            <span>
                <i class="fas fa-dumbbell"></i>
                Stärken & Schwächen
            </span>
        </h3>

        @if (digiTrainerContent && digiTrainerContent?.training?.individual?.length) {
            @for (individual of digiTrainerContent.training.individual; track $index) {
                <button class="btn btn-round"
                        (click)="quicklinkClick(individual.assignments)"
                        [disabled]="!individual.assignments.length"
                        title="Übungen öffnen"
                >
                    {{ individual.name }}
                </button>
            }
        } @else {
            <button class="btn btn-round"
                    title="nicht verfügbar"
                    disabled
            >
                an meinen Stärken arbeiten
            </button>
            <button class="btn btn-round"
                    title="nicht verfügbar"
                    disabled
            >
                meine Schwächen verbessern
            </button>
        }
    </div>

    <div class="digi-trainer-content goals-competences">
        <h3>
            <span>
                <i class="fas fa-bullseye-arrow"></i>
                Lernziele & Kompetenzen
            </span>
        </h3>

        @if (digiTrainerContent && digiTrainerContent?.training?.competence?.length) {
            <ul>
                @for (competence of digiTrainerContent.training.competence; track competence) {
                    <li>
                        <button (click)="quicklinkClick(competence.assignment)">
                            <div class="name">{{ competence.name }}</div>
                            <div>
                                <i class="far fa-arrow-right fa-rotate-by"></i>
                            </div>
                        </button>
                    </li>
                }
            </ul>
        }
    </div>

    <div class="digi-trainer-content chapter">
        <h3>
            <span>
                <i class="fas fa-bookmark"></i>
                Passend zum Kapitel
            </span>
        </h3>

        @if (digiTrainerContent?.training?.exercises?.length) {
            <ul>
                @for (exercise of digiTrainerContent.training.exercises; track exercise) {
                    <li>
                        <button (click)="quicklinkClick(exercise.assignment ?? exercise.assignments)">
                            <div class="name">
                                {{ exercise.name }}
                            </div>
                            <div>
                                <i class="far fa-arrow-right fa-rotate-by"></i>
                            </div>
                        </button>
                    </li>
                }
            </ul>
        }
    </div>
</div>